import React from 'react';

export default function SearchIcon({className}:any) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9ZM9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C11.1251 18 13.0781 17.2635 14.6178 16.0318L18.2931 19.7071C18.6836 20.0976 19.3168 20.0976 19.7073 19.7071C20.0978 19.3165 20.0978 18.6834 19.7073 18.2928L16.032 14.6175C17.2636 13.0779 18 11.125 18 9C18 4.02944 13.9706 0 9 0Z" className={className || "white"}/>
		</svg>

	)
}